import { render } from "./AddTransport.vue?vue&type=template&id=8297c460&scoped=true"
import script from "./AddTransport.vue?vue&type=script&lang=js"
export * from "./AddTransport.vue?vue&type=script&lang=js"

import "./AddTransport.vue?vue&type=style&index=0&id=8297c460&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8297c460"]])

export default __exports__